import { Flex } from '@/lib/v2/components/Layout/Stack';

import { BigColumnSkeleton } from '..';

export const TableSkeleton = () => {
  return (
    <Flex>
      <BigColumnSkeleton />
      <BigColumnSkeleton />
      <BigColumnSkeleton />
      <BigColumnSkeleton />
      <BigColumnSkeleton />
    </Flex>
  );
};
